import { fmtCurrencyFull, fmtPct } from "@/lib/calc";

const RevenueSplit = ({ client, currency = "USD" }) => {
  const revenue = client.monthly_fee || 0;
  const cost = client.estimated_cost || 0;
  const profit = client.estimated_profit || 0;

  const safeRev = Math.max(revenue, 1);
  const costPct = Math.min((Math.max(cost, 0) / safeRev) * 100, 100);
  const profitPct = Math.max(0, Math.min((Math.max(profit, 0) / safeRev) * 100, 100 - costPct));
  const lossPct = profit < 0 ? Math.min((Math.abs(profit) / safeRev) * 100, 100) : 0;

  return (
    <div className="mt-1" data-testid="revenue-split">
      <div className="flex items-baseline justify-between text-xs text-[#69747C] mb-2">
        <span>Where the retainer goes</span>
        <span className="tabular-nums">
          {fmtPct((Math.max(cost, 0) / safeRev) * 100)} cost ·{" "}
          {fmtPct(client.profit_margin || 0)} margin
        </span>
      </div>
      <div className="w-full bg-[#F0EADA] rounded-full h-2.5 overflow-hidden flex">
        {costPct > 0 ? (
          <div
            className="bg-[#1F2326] h-2.5 transition-all duration-500"
            style={{ width: `${costPct}%` }}
            title="Costs to service"
          />
        ) : null}
        {profitPct > 0 ? (
          <div
            className="bg-[#6F9775] h-2.5 transition-all duration-500"
            style={{ width: `${profitPct}%` }}
            title="Profit"
          />
        ) : null}
        {lossPct > 0 ? (
          <div
            className="bg-[#C76055] h-2.5 transition-all duration-500"
            style={{ width: `${Math.min(lossPct, 100)}%` }}
            title="Loss"
          />
        ) : null}
      </div>
      <div className="flex flex-wrap gap-x-5 gap-y-1 mt-3 text-xs">
        <span className="inline-flex items-center gap-1.5 text-[#69747C]">
          <span className="w-2 h-2 rounded-full bg-[#1F2326]" /> Costs to service{" "}
          <span className="font-medium text-[#1F2326] tabular-nums">
            {fmtCurrencyFull(cost, currency)}
          </span>
        </span>
        <span className="inline-flex items-center gap-1.5 text-[#69747C]">
          <span
            className={`w-2 h-2 rounded-full ${
              profit >= 0 ? "bg-[#6F9775]" : "bg-[#C76055]"
            }`}
          />{" "}
          {profit >= 0 ? "Profit" : "Loss"}{" "}
          <span
            className={`font-medium tabular-nums ${
              profit >= 0 ? "text-[#42624B]" : "text-[#7E332D]"
            }`}
          >
            {fmtCurrencyFull(profit, currency)}
          </span>
        </span>
        <span className="inline-flex items-center gap-1.5 text-[#69747C]">
          <span className="w-2 h-2 rounded-full bg-[#E4DFD2]" /> Revenue{" "}
          <span className="font-medium text-[#1F2326] tabular-nums">
            {fmtCurrencyFull(revenue, currency)}
          </span>
        </span>
      </div>
    </div>
  );
};

export default RevenueSplit;
